import usePosOrderCurrentAction from "@/shared/atoms/usePosOrderCurrentAction";
import useElectronHook from "@/shared/hooks/useElectronHook";
import useOpenCashDrawerHook from "@/shared/hooks/useOpenCashDrawerHook";
import useActionClick from "./useActionClick";
import PosMenuBottomActionButton, {
  PosMenuAction,
} from "../PosMenu/PosMenuBottomActionButton";
import { useTranslation } from "react-i18next";
import { CurrentActionTypes } from "@/shared/atoms/usePosOrderCurrentAction";

const useOpenCashDrawerAction = (): PosMenuAction => {
  const { t } = useTranslation();
  const { isElectron } = useElectronHook();
  const openCashDrawer = useOpenCashDrawerHook();

  return {
    name: "openCashDrawer" as CurrentActionTypes,
    label: t("posOrders.openCashDrawer"),
    set: openCashDrawer,
    instantSet: true,
    filtered: isElectron === false,
    disabled: false,
    iconVariant: "cashDrawer",
  };
};

const OpenCashDrawerAction = () => {
  const [currentAction] = usePosOrderCurrentAction();
  const action = useOpenCashDrawerAction();
  const handleClick = useActionClick(action);

  return (
    <PosMenuBottomActionButton
      action={action}
      isSelected={currentAction?.name === action.name}
      onClick={handleClick}
    />
  );
};

export default OpenCashDrawerAction;
